module.exports = __webpack_public_path__ + "static/media/dashboard-pro-bookcall.e010f40d.svg";